// Only initialize on the contact page; keep the existing API payload unchanged.
const form = document.getElementById("contactForm");
if (form) {
  const fields = ["name", "email", "message"].map((id) => document.getElementById(id));
  const button = document.getElementById("btn-contact");
  const text = document.getElementById("btn-text");
  const loader = document.getElementById("btn-loader");
  const notice = document.getElementById("notify_contact");
  let pending = false;
  form.noValidate = true;
  button.disabled = false;

  const setError = (field, message = "") => {
    const error = document.getElementById(`${field.id}Error`);
    error.textContent = message;
    error.hidden = !message;
    if (message) field.setAttribute("aria-invalid", "true");
    else field.removeAttribute("aria-invalid");
  };
  const notify = (message, state) => {
    notice.textContent = message;
    notice.dataset.state = state;
    notice.hidden = false;
  };
  fields.forEach((field) => field.addEventListener("input", () => setError(field)));

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (pending) return;
    notice.hidden = true;
    fields.forEach((field) => {
      field.value = field.value.trim();
      let error = "";
      if (!field.value) error = field.id === "message" ? "Please enter a message." : `Please enter your ${field.id}.`;
      else if (field.id === "email" && !field.validity.valid) error = "Please enter a valid email address.";
      else if (field.id === "name" && field.value.length > 100) error = "Please keep your name to 100 characters or fewer.";
      setError(field, error);
    });
    const invalid = fields.find((field) => field.hasAttribute("aria-invalid"));
    if (invalid) { invalid.focus(); return; }

    const payload = Object.fromEntries(fields.map((field) => [field.name, field.value]));
    pending = true;
    button.disabled = true;
    fields.forEach((field) => { field.disabled = true; });
    form.setAttribute("aria-busy", "true");
    text.hidden = true;
    loader.hidden = false;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch("https://bluemint.ai/api/contact-us/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });
      if (response.ok) {
        form.reset();
        notify("Thank you! Your message has been sent.", "success");
      } else {
        const data = await response.json().catch(() => ({}));
        let fieldErrors = false;
        fields.forEach((field) => {
          const error = data?.errors?.[field.name];
          const messages = Array.isArray(error) ? error.filter((value) => typeof value === "string").join(" ") : typeof error === "string" ? error : "";
          if (messages) { setError(field, messages); fieldErrors = true; }
        });
        notify(fieldErrors ? "Please check the highlighted fields and try again." : "We couldn’t send your message. Please try again or email support@bluemint.ai.", "error");
      }
    } catch {
      notify("We couldn’t confirm your message was sent. Please try again or email support@bluemint.ai.", "error");
    } finally {
      clearTimeout(timeout);
      pending = false;
      button.disabled = false;
      fields.forEach((field) => { field.disabled = false; });
      form.removeAttribute("aria-busy");
      text.hidden = false;
      loader.hidden = true;
      fields.find((field) => field.hasAttribute("aria-invalid"))?.focus();
    }
  });
}
